import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[appOnReturn]'
})
export class AppOnReturnDirective {
    private el: ElementRef;
    @Input() onReturn: string;
    constructor(private _el: ElementRef) {
        console.log('ELEMENTO' + this.el);
        this.el = this._el;
    }
    @HostListener('keydown', ['$event']) onKeyDown(e) {
        if ((e.which === 13 || e.keyCode === 13)) {
            console.log('ENTER PRESSED');
            // e.preventDefault();
            if (e.srcElement.nextElementSibling) {
                e.srcElement.nextElementSibling.focus();
            } else {
                console.log('close keyboard');
            }
            return;
        }

    }

}
